const _import = require('@/utils/import/_import_' + process.env.NODE_ENV)

export default [
  {
    path: 'logs',
    component: {
      template: '<div class="content-wrapper"><router-view></router-view></div>'
    },
    name: 'Logs',
    meta: {
      title: 'Логи',
      menuKey: 'Settings'
    },
    children: [
      {
        path: '',
        component: _import('logs/components/list'),
        name: 'Logs.list',
        meta: {
          title: 'Логи',
          menuKey: 'Settings'
        }
      },
      // {
      //   path: 'create',
      //   component: _import('products/components/products/create'),
      //   name: 'Goods.create'
      // },
      // {
      //   path: 'edit/:id',
      //   component: _import('products/components/products/edit'),
      //   name: 'Goods.edit'
      // }
    ]

  },
]



// WEBPACK FOOTER //
// ./src/modules/logs/routes.js